import { render, staticRenderFns } from "./sliderArticle.module.vue?vue&type=template&id=205a5e56&scoped=true"
import script from "./sliderArticle.module.vue?vue&type=script&lang=js"
export * from "./sliderArticle.module.vue?vue&type=script&lang=js"
import style0 from "./sliderArticle.module.vue?vue&type=style&index=0&id=205a5e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a5e56",
  null
  
)

export default component.exports